import ModuleFooterList from './ModuleFooterList.vue';

export default ModuleFooterList;



// WEBPACK FOOTER //
// ./src/components/parts/modules/modulefooter/components/modulefooterlist/index.ts